<script setup>
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  error: {},
  snackbar: {},
  margin: { required: false, default: 0 },
  timeout: { required: false, default: 4000 }
})

const internalSnackbar = computed({
  get() {
    return props.snackbar
  },
  set() {
    emit('set')
  }
})

const errorText = ref('')

const getErrorText = async () => {
  const response = await props.error?.response
  if (response?.data instanceof Blob) {
    errorText.value = await response.data.text()
  } else if (typeof response.data === 'string') {
    errorText.value = response.data
  }
  errorText.value = errorText.value.replaceAll('"', '')
}

const emit = defineEmits(['set'])

onMounted(async () => {
  await getErrorText()
})
</script>
<template>
  <v-snackbar
    v-model="internalSnackbar"
    color="red"
    :timeout="timeout"
    :style="{ 'margin-bottom': `${margin}px` }"
  >
    <div v-if="error">
      <span class="mt-1">{{ error.response?.statusText }}: {{ error.response?.data?.detail }}</span>
      <v-chip label color="white" variant="outlined" size="small" class="ml-2">
        {{ error.response?.status }}
      </v-chip>
      <div v-if="error.response?.status === 400" class="mt-4 ml-3 mr-3">
        <v-divider class="mb-2" />
        <template v-if="errorText">
          {{ errorText }}
        </template>
        <template v-else>
          <v-row v-for="errorMessage in error.response?.data" :key="errorMessage.id">
            <v-col class="mt-4 mb-2">
              <template v-if="typeof errorMessage === 'object'">
                <v-row v-for="(error, key) in errorMessage" :key="key">
                  <v-col class="pa-0">
                    <div v-if="typeof error === 'object'">
                      <strong>{{ key }}: </strong>
                      <span v-for="err in error" :key="err">
                        {{ err }}
                      </span>
                    </div>
                    <div v-else>
                      <strong>{{ key + 1 }}: </strong>
                      <span> {{ error }} </span>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row>
                  <v-col class="pa-0">
                    <div>
                      <span> {{ errorMessage }} </span>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </template>
      </div>
      <div v-else-if="error.response?.status === 500 && Array.isArray(error.response.data)">
        <v-divider class="mt-2 mb-2" />
        <v-row v-for="errorMessage in error.response.data" :key="errorMessage.id">
          <v-col :key="errorMessage.id" class="mb-2">
            {{ errorMessage }}
          </v-col>
        </v-row>
      </div>
    </div>

    <template #actions>
      <v-btn icon size="small" variant="text" @click="internalSnackbar = false">
        <v-icon size="small"> mdi-close-circle </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
